export default __webpack_public_path__ + "static/Automated-Processes-cbd0c0e6ad2544bdb5368d29934e0432.webp";